module.exports = __webpack_public_path__ + "assets/aba7eda568a9a0f37921f2a43a740ed8.mp3";